export const getEStoreTopMenuList = state => {
    return state.list
}

export const getEStoreTopMenuDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreTopMenu/getters.js